import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";

import { FileService } from "src/services/file.service";
import Truncate from "src/components/truncate";
import Collapse from "../animation/collapse";

import _ from "lodash";
import cx from "classnames";
import styles from "./recommendedAssets.module.scss";
import { Link} from "react-router-dom";
import Tooltip from "src/components/tooltip";

interface RecommendedAssetsProps {
  onExpand: () => void;
  onClose: () => void;
}

const RecommendedAssets: React.FC<RecommendedAssetsProps> = ({
  onExpand,
  onClose,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [showViewMore, setShowViewMore] = useState(false);
  const [rotated, setRotated] = useState(false);
  const [showMoreAssets, setShowMoreAssets] = useState(false);
  const [collapsed, setCollapsed] = useState(false);

  const recommendedAssets = useSelector((state: any) =>
    _.get(state, "asset.recommended.items", []),
  );
  const handleViewMore = () => {
    setShowMoreAssets(true);
    setIsExpanded(false);
  };

  const handleClose = () => {
    onClose();
  };
  useEffect(() => {
    if (recommendedAssets?.length > 0) {
      setTimeout(() => setIsExpanded(true), 1000);
      setTimeout(() => setShowViewMore(true), 1000);
    }
  }, [recommendedAssets]);

  const assetsSize = recommendedAssets.length;

  if (assetsSize === 1) {
    return <AssetCard asset={recommendedAssets[0]} />;
  }

  return (

    <section>
      {!showMoreAssets && (
        <div
          className={cx(styles.dummyCard, {
            [styles.dummyCardExpanded]: isExpanded,
          })}
        ></div>
      )}

      <div
        className={cx(
          styles.recommendations,
          { [styles.expanded]: isExpanded },
          { [styles.showMoreAssets]: showMoreAssets && !collapsed },
          { [styles.collapsed]: collapsed },
        )}
      >
        {assetsSize > 0 && !showMoreAssets && (
          <div><AssetCard asset={recommendedAssets[0]} /><i
            className={cx(styles.closeButton, "paperflite-close")}
            onClick={handleClose}
          ></i></div>
        )}

        <Collapse isOpen={showMoreAssets}>
          <div className={cx(styles.popupDialog,{
            [styles.popupDialogExpanded]: showMoreAssets,
          })}>
            <div className={styles.header}>
              <span className={styles.titleContainer}
                  onClick={() => {
                    onExpand();
                    setCollapsed(!collapsed);
                    setRotated((prev) => !prev);
                  }}
              >
              <p
                className={styles.title}
              >
                Recommended Assets
              </p>
              <i
                className={cx(styles.upArrow, "paperflite-dropdown", {
                  [styles.rotated]: rotated,
                })}
              ></i>
              </span>
              <i
                className={cx(styles.closeIcon, "paperflite-close")}
                onClick={handleClose}
              ></i>
            </div>
            <div className={cx(styles.assets)}>
              {recommendedAssets.map((record, index) => {
                const assetDTO = record.assetDTO;
                return <AssetCard key={assetDTO.index} asset={record} />;
              })}
            </div>
          </div>
        </Collapse>

        {showViewMore && !showMoreAssets && (
          <div className={styles.viewMoreContainer} onClick={handleViewMore}>
            <span className={styles.viewMoreButton} >View more</span>
            <i className={cx("paperflite-up-arrow")}></i>
          </div>
        )}
      </div>
      </section>

    );
};

interface AssetCardProps {
  asset: any;
}

const AssetCard: React.FC<AssetCardProps> = ({ asset }) => {
  const assetDTO = asset.assetDTO;
  const metadata = assetDTO.metadata;
  const analytics = assetDTO.analytics;
  return (
    <Link to={`/assets/${assetDTO.id}`} className={cx(styles.container)}>
      <div className={styles.iconContainer}>
        <img
          src={_.get(assetDTO,"icon.thumbnail", "/images/assets/default_asset.jpg")}
          className={styles.thumbnail}
          alt="Thumbnail"
        />
      </div>

      <div className={styles.information}>
        <div className={styles.metadata}>
          <Truncate width={178} lines={1} className={styles.name}>
            <Tooltip
              content={assetDTO.name}
              placement="bottom"
            >
              <span>{assetDTO.name}</span>
            </Tooltip>
          </Truncate>
          {metadata && analytics && (
            <div className={styles.file}>
              <div className={styles.fileType}>
                {FileService.getFileType(metadata)}
              </div>
              <div className={styles.line}></div>
              <div className={styles.fileSize}>
                {FileService.formatSize(metadata.content_length)}
              </div>
              {metadata && metadata.pages && (
                <>
                  <div className={styles.line}></div>
                  <div>{metadata.pages} Pages</div>
                </>
              )}
              {analytics && analytics.avgTimeSpent && (
                <>
                  <div className={styles.line}></div>
                  <div> ~ {Math.round(analytics.avgTimeSpent / 60)} min</div>
                </>
              )}
            </div>
          )}
        </div>

        {analytics && (
          <div className={styles.analyticsContainer}>
            <div className={styles.analytics}>
              <span className={styles.data}>{analytics.views}</span>
              <span className={styles.label}> Views</span>
            </div>
            <div className={styles.line}></div>
            <div className={styles.analytics}>
              <span className={styles.data}>{analytics.downloads}</span>
              <span className={styles.label}> Downloads</span>
            </div>
            <div className={styles.line}></div>
            <div className={styles.analytics}>
              <span className={styles.data}>{analytics.shares}</span>
              <span className={styles.label}> Shares</span>
            </div>
          </div>
        )}
    </div>
    </Link>
  );
};

export default RecommendedAssets;
